import { TabItem } from '@shared/components/tabs/types';
import { Component } from 'vue';
import { PromotionHubClickEventLabels } from './PromotionHubClickEventLabels';

export const PromotionHubTab = {
    Offers: 'Offers',
    InProgress: 'InProgress',
    Bonuses: 'Bonuses',
    History: 'History',
    Rewards: 'Rewards',
} as const;
export type PromotionHubTab = typeof PromotionHubTab[keyof typeof PromotionHubTab];

export const promotionHubTabAnalytics: Record<PromotionHubTab, PromotionHubClickEventLabels> = {
    [PromotionHubTab.Offers]: PromotionHubClickEventLabels.promotionsTab,
    [PromotionHubTab.InProgress]: PromotionHubClickEventLabels.inProgressTab,
    [PromotionHubTab.Bonuses]: PromotionHubClickEventLabels.bonusTab,
    [PromotionHubTab.History]: PromotionHubClickEventLabels.historyTab,
    [PromotionHubTab.Rewards]: PromotionHubClickEventLabels.bonusTab,
};

export type PromotionHubTabItem = TabItem & {
    component: Component;
};
